import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DSection @pageClass="user-preferences-tracking" />

<div class="user-preferences__tracking-topics-wrapper">
  <label class="control-label">{{i18n "user.topics_settings"}}</label>

  <div class="user-preferences_tracking-topics-controls">
    <div
      class="controls controls-dropdown"
      data-setting-name="user-new-topic-duration"
    >
      <label>{{i18n "user.new_topic_duration.label"}}</label>
      <ComboBox
        @valueProperty="value"
        @content={{this.considerNewTopicOptions}}
        @value={{this.model.user_option.new_topic_duration_minutes}}
        @onChange={{action
          (mut this.model.user_option.new_topic_duration_minutes)
        }}
        class="duration"
      />
    </div>

    <div
      class="controls controls-dropdown"
      data-setting-name="user-auto-track-topics"
    >
      <label>{{i18n "user.auto_track_topics"}}</label>
      <ComboBox
        @valueProperty="value"
        @content={{this.autoTrackDurations}}
        @value={{this.model.user_option.auto_track_topics_after_msecs}}
        @onChange={{action
          (mut this.model.user_option.auto_track_topics_after_msecs)
        }}
      />
    </div>

    <div
      class="controls controls-dropdown"
      data-setting-name="user-notification-level-when-replying"
    >
      <label>{{i18n "user.notification_level_when_replying"}}</label>
      <ComboBox
        @valueProperty="value"
        @content={{this.notificationLevelsForReplying}}
        @value={{this.model.user_option.notification_level_when_replying}}
        @onChange={{action
          (mut this.model.user_option.notification_level_when_replying)
        }}
      />
    </div>

    <PreferenceCheckbox
      @labelKey="user.topics_unread_when_closed"
      @checked={{this.model.user_option.topics_unread_when_closed}}
    />
  </div>
</div>

<div class="user-preferences__tracking-categories-tags-wrapper">
  <div>
    <UserPreferences::Categories
      @canSee={{this.canSee}}
      @model={{this.model}}
      @selectedCategories={{this.selectedCategories}}
      @hideMutedTags={{this.hideMutedTags}}
      @siteSettings={{this.siteSettings}}
    />
  </div>

  <div>
    <UserPreferences::Tags
      @model={{this.model}}
      @selectedTags={{this.selectedTags}}
      @save={{this.save}}
      @siteSettings={{this.siteSettings}}
    />
  </div>
</div>
{{#if this.showMutePrecedenceSetting}}
  <div class="control-group user-preferences__watched-precedence-over-muted">
    <PreferenceCheckbox
      data-setting-name="watched-precedence-over-muted"
      @labelKey="user.watched_precedence_over_muted"
      @checked={{this.model.user_option.watched_precedence_over_muted}}
    />
  </div>
{{/if}}

{{#if this.canSave}}
  <SaveControls
    @model={{this.model}}
    @action={{this.save}}
    @saved={{this.saved}}
  />
{{/if}}
*/
{
  "id": "KVGZRjX2",
  "block": "[[[8,[39,0],null,[[\"@pageClass\"],[\"user-preferences-tracking\"]],null],[1,\"\\n\\n\"],[10,0],[14,0,\"user-preferences__tracking-topics-wrapper\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,1],[\"user.topics_settings\"],null]],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"user-preferences_tracking-topics-controls\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"controls controls-dropdown\"],[14,\"data-setting-name\",\"user-new-topic-duration\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,1],[\"user.new_topic_duration.label\"],null]],[13],[1,\"\\n      \"],[8,[39,2],[[24,0,\"duration\"]],[[\"@valueProperty\",\"@content\",\"@value\",\"@onChange\"],[\"value\",[30,0,[\"considerNewTopicOptions\"]],[30,0,[\"model\",\"user_option\",\"new_topic_duration_minutes\"]],[28,[37,3],[[30,0],[28,[37,4],[[30,0,[\"model\",\"user_option\",\"new_topic_duration_minutes\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"controls controls-dropdown\"],[14,\"data-setting-name\",\"user-auto-track-topics\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,1],[\"user.auto_track_topics\"],null]],[13],[1,\"\\n      \"],[8,[39,2],null,[[\"@valueProperty\",\"@content\",\"@value\",\"@onChange\"],[\"value\",[30,0,[\"autoTrackDurations\"]],[30,0,[\"model\",\"user_option\",\"auto_track_topics_after_msecs\"]],[28,[37,3],[[30,0],[28,[37,4],[[30,0,[\"model\",\"user_option\",\"auto_track_topics_after_msecs\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"controls controls-dropdown\"],[14,\"data-setting-name\",\"user-notification-level-when-replying\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,1],[\"user.notification_level_when_replying\"],null]],[13],[1,\"\\n      \"],[8,[39,2],null,[[\"@valueProperty\",\"@content\",\"@value\",\"@onChange\"],[\"value\",[30,0,[\"notificationLevelsForReplying\"]],[30,0,[\"model\",\"user_option\",\"notification_level_when_replying\"]],[28,[37,3],[[30,0],[28,[37,4],[[30,0,[\"model\",\"user_option\",\"notification_level_when_replying\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,5],null,[[\"@labelKey\",\"@checked\"],[\"user.topics_unread_when_closed\",[30,0,[\"model\",\"user_option\",\"topics_unread_when_closed\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"user-preferences__tracking-categories-tags-wrapper\"],[12],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@canSee\",\"@model\",\"@selectedCategories\",\"@hideMutedTags\",\"@siteSettings\"],[[30,0,[\"canSee\"]],[30,0,[\"model\"]],[30,0,[\"selectedCategories\"]],[30,0,[\"hideMutedTags\"]],[30,0,[\"siteSettings\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[12],[1,\"\\n    \"],[8,[39,7],null,[[\"@model\",\"@selectedTags\",\"@save\",\"@siteSettings\"],[[30,0,[\"model\"]],[30,0,[\"selectedTags\"]],[30,0,[\"save\"]],[30,0,[\"siteSettings\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"showMutePrecedenceSetting\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group user-preferences__watched-precedence-over-muted\"],[12],[1,\"\\n    \"],[8,[39,5],[[24,\"data-setting-name\",\"watched-precedence-over-muted\"]],[[\"@labelKey\",\"@checked\"],[\"user.watched_precedence_over_muted\",[30,0,[\"model\",\"user_option\",\"watched_precedence_over_muted\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canSave\"]],[[[1,\"  \"],[8,[39,9],null,[[\"@model\",\"@action\",\"@saved\"],[[30,0,[\"model\"]],[30,0,[\"save\"]],[30,0,[\"saved\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"d-section\",\"i18n\",\"combo-box\",\"action\",\"mut\",\"preference-checkbox\",\"user-preferences/categories\",\"user-preferences/tags\",\"if\",\"save-controls\"]]",
  "moduleName": "discourse/templates/preferences/tracking.hbs",
  "isStrictMode": false
});